// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amount-text[data-v-5d527a48] {\n  font-weight: 500;\n  color: #1890ff;\n}\n.no-config[data-v-5d527a48] {\n  text-align: center;\n  padding: 20px;\n}\npre[data-v-5d527a48] {\n  white-space: pre-wrap;\n  word-break: break-all;\n  background-color: #f6f8fa;\n  padding: 8px;\n  border-radius: 4px;\n  margin: 0;\n}\n.ant-descriptions-item-label[data-v-5d527a48] {\n  font-weight: 500;\n}\n.ant-descriptions-item-content[data-v-5d527a48] {\n  word-break: break-all;\n}\n", ""]);
// Exports
module.exports = exports;
